import useSWR from 'swr';
import { useToken } from '../../../../app/hooks';
import API from '../../../../utils/api';

interface PopupListResponse {
  list: any[];
  total: number;
  maxPage: number;
}

const M_KEY = '/admin/popup/list';

const buildQuery = (
  page: number,
  maxData: number,
  status: 'all' | 'active' | 'inactive',
  keyword: string,
) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('maxData', String(maxData));
  if (status && status !== 'all') params.set('status', status);
  if (keyword) params.set('keyword', keyword);
  return `${M_KEY}?${params.toString()}`;
};

export function useAdminPopupList(
  page: number,
  maxData: number,
  status: 'all' | 'active' | 'inactive',
  keyword: string,
) {
  const { data: token } = useToken();
  const KEY = buildQuery(page, maxData, status, keyword);
  const fetcher = () => fetchAPI(KEY, token);

  const { data, mutate, isLoading } = useSWR<PopupListResponse>(
    token ? KEY : null,
    fetcher,
    { revalidateOnFocus: true },
  );

  return {
    popupList: data?.list ?? [],
    total: data?.total ?? 0,
    maxPage: data?.maxPage ?? 1,
    mutatePopupList: mutate,
    isLoading,
  };
}

async function fetchAPI(KEY: string, token: any): Promise<PopupListResponse> {
  try {
    const response = await API.get(`${KEY}`, token + '', {});
    const result = response?.result?.result ?? {};
    return {
      list: result.list ?? [],
      total: result.totalCount ?? 0,
      maxPage: result.maxPage ?? 1,
    };
  } catch (error) {
    console.error('Failed to fetch popup list:', error);
    return { list: [], total: 0, maxPage: 1 };
  }
}
